import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { CloseOutlined } from '@teko/ds-icon';
import { SwiperCore, Navigation, Thumbs, Swiper, SwiperSlide, styled, LazyImage } from '@teko/ds-desktop';

const Gallery = ({ images, activeImageIndex = 0, onClose, bgColor, }) => {
    SwiperCore.use([Navigation, Thumbs]);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    return (jsxs(Wrapper, Object.assign({ bgColor: bgColor }, { children: [jsx(Header, { children: onClose && (jsx(ButtonClose, Object.assign({ onClick: onClose }, { children: jsx(CloseOutlined, { size: 36, color: "textSecondary" }, void 0) }), void 0)) }, void 0), jsx(StyledContainer, { children: jsx(Swiper, Object.assign({ thumbs: { swiper: thumbsSwiper }, initialSlide: activeImageIndex, slidesPerView: 1, slidesPerGroup: 1, navigation: true }, { children: images.map((image, index) => (jsx(SwiperSlide, { children: jsx(ImageWrapper, Object.assign({ className: "swiper-slide" }, { children: jsx(StyledImage, Object.assign({ contain: true, imageWidth: 1000 }, image), void 0) }), void 0) }, index))) }), void 0) }, void 0), !!images.length && (jsx(Footer, { children: jsx(Swiper, Object.assign({ className: "gallery-thumbs", onSwiper: setThumbsSwiper, watchSlidesVisibility: true, watchSlidesProgress: true, spaceBetween: 10 }, { children: images.map((image, index) => (jsx(SwiperSlide, { children: jsx(Thumbnail, Object.assign({}, image, { contain: true, width: 60, height: 60, imageWidth: 150, borderRadius: 4, onClick: () => setThumbsSwiper(index) }), void 0) }, index))) }), void 0) }, void 0))] }), void 0));
};
const Wrapper = styled.div(({ bgColor }) => `
  background-color: ${bgColor};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
`);
const Header = styled.div `
  display: flex;
  justify-content: flex-end;
  height: 36px;
  align-items: center;
  z-index: 3;
`;
const Footer = styled.div `
  margin: 1rem auto;
  padding: 0 1rem;
  width: 1200px;
  z-index: 3;
  .swiper-slide {
    width: auto !important;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = styled(LazyImage) `
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const ImageWrapper = styled.div `
  background: transparent;
`;
const StyledContainer = styled.div `
  height: calc(100vh - 130px);
  z-index: 4;
  width: 100%;
  > div,
  .swiper-container {
    height: 100%;
    width: 100%;
  }
  .swiper-wrapper {
    height: 100% !important;
    width: 100% !important;
  }
  &:hover {
    .swiper-button-next,
    .swiper-button-prev {
      opacity: 1;
      &.swiper-button-disabled {
        opacity: 0.35;
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    margin-top: -22px;
    opacity: 0;
    &.swiper-button-disabled {
      opacity: 0;
      cursor: auto;
      pointer-events: auto;
    }
  }
  .swiper-button-next {
    right: 0;
    left: auto;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
    background-color: rgba(168, 168, 168, 0.46);
    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }
  .swiper-button-prev {
    left: 0;
    right: auto;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    background-color: rgba(168, 168, 168, 0.46);
    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }
`;
const Thumbnail = styled(LazyImage) `
  cursor: pointer;
  transition: 0.1s ease opacity;
  &:hover {
    opacity: 0.6;
  }
`;
const ButtonClose = styled.div(({ theme }) => `
  cursor: pointer;
  padding: 4px;
  &:hover {
    path{
      fill: ${theme.colors.primary500} !important;
    }
  }
`);

export { Gallery as G };
